import { NgModule } from '@angular/core';

import { SearchRoutingModule } from './search-routing.module';
import { RepresentativeSearchComponent } from './representative-search/representative-search.component';
import { SharedModule } from '../shared/shared.module';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import {
  MultiSelectAllModule,
  MultiSelectModule,
} from '@syncfusion/ej2-angular-dropdowns';
// import { AgmCoreModule } from '@agm/core';
// import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { AvatarModule } from 'ngx-avatars';
import { NgMapsCoreModule } from '@ng-maps/core';
import { NgMapsGoogleModule } from '@ng-maps/google';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { ShareModalComponent } from './share-modal/share-modal/share-modal.component';


@NgModule({
  declarations: [RepresentativeSearchComponent],
  imports: [
    SearchRoutingModule,
    SharedModule,
    AutocompleteLibModule,
    MultiSelectModule,
    MultiSelectAllModule,
    SearchRoutingModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyAYw--XnOw-_q_UuvnT7w4xeegfJSaa2bM&language=en&region=us',
    //   libraries: ['places'],
    // }),
    AvatarModule,
    NgMapsCoreModule,
    NgMapsGoogleModule,
    NgMapsGoogleModule.forRoot({
      apiKey: 'AIzaSyAYw--XnOw-_q_UuvnT7w4xeegfJSaa2bM',
      libraries: ['places'],
    }),
    // MatGoogleMapsAutocompleteModule.forRoot(
    //   'AIzaSyAYw--XnOw-_q_UuvnT7w4xeegfJSaa2bM'
    // ),
    ShareButtonsModule.withConfig({
      debug: true,
    }),
    ShareIconsModule,
    ShareModalComponent
  ],
  exports: [RepresentativeSearchComponent],
  // providers: [
  //   {
  //     provide: GOOGLE_MAPS_API_CONFIG,
  //     useValue: {
  //       apiKey: 'AIzaSyAYw--XnOw-_q_UuvnT7w4xeegfJSaa2bM&language=en&region=us',
  //       libraries: ['places'],
  //     },
  //   },
  // ],
})
export class SearchModule {}
